import { MdOutlineMonitorHeart } from "react-icons/md";
import "../../../css/IconStyle.css";

const JobMonitoringIcon = () => {
  return <MdOutlineMonitorHeart size={22} className="sidebar-icon" />;
};

export default JobMonitoringIcon;
